import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../config/environments/environment';

import { Room } from '../models/interfaces/room.interface';
import { RoomDto } from '../models/dto/room.dto';
import { MembersRoomDto } from '../models/dto/room-members.dto';
import { createMembers } from '../utils/rooms-members.utils';

@Injectable()
export class RoomsService {
  private readonly path = 'rooms';

  constructor(private http: HttpClient) {}

  getAll(idUser: string): Observable<Room[]> {
    return this.http.get<Room[]>(`${environment.api.baseUrl}/${this.path}/v2`, {
      params: { idUser },
    });
  }

  getById(id: string): Observable<Room> {
    return this.http.get<Room>(`${environment.api.baseUrl}/${this.path}/${id}`);
  }

  create(room: Room): Observable<Room> {
    return this.http.post<Room>(
      `${environment.api.baseUrl}/${this.path}`,
      JSON.stringify(room)
    );
  }

  addMemberstoRoom(roomName: string, addMembers: string[]): Promise<any> {
    const members: MembersRoomDto = createMembers(roomName, addMembers);
    return this.http
      .patch(`${environment.api.baseUrl}/${this.path}/add-members`, members)
      .toPromise();
  }

  removeMembersFromRoom(
    roomName: string,
    removeMembers: string[]
  ): Promise<any> {
    const members: MembersRoomDto = createMembers(roomName, removeMembers);
    return this.http
      .patch(`${environment.api.baseUrl}/${this.path}/remove-members`, members)
      .toPromise();
  }

  rename(oldName: string, newName: string): Promise<void> {
    return this.http
      .patch<void>(`${environment.api.baseUrl}/${this.path}/rename`, {
        previous: oldName,
        name: newName,
      })
      .toPromise();
  }

  getByChannels(idsChannels: string[]): Observable<RoomDto[]> {
    return this.http.get<RoomDto[]>(`${environment.api.baseUrl}/${this.path}`, {
      params: {
        channels: idsChannels,
      },
      headers: {
        'Cache-Control': 'no-cache',
      }
    });
  }
}
